"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/app/front/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/app/front/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/app/front/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaxUser = void 0;

var universal_authenticator_library_1 = require("universal-authenticator-library");

var UALWaxError_1 = require("./UALWaxError");

var WaxUser = /*#__PURE__*/function (_universal_authentica) {
  _inherits(WaxUser, _universal_authentica);

  var _super = _createSuper(WaxUser);

  function WaxUser(chain, userAccount, pubKeys, isTemp, wax) {
    var _this;

    _classCallCheck(this, WaxUser);

    _this = _super.call(this);
    _this.accountName = userAccount;
    _this.requestPermission = 'active';
    _this.pubKeys = pubKeys;
    _this.isTemp = isTemp;
    _this.chain = chain;
    _this.wax = wax; // compatible features

    _this.api = wax.api;
    _this.rpc = wax.api && wax.api.rpc;
    return _this;
  }
  /**
   * @param transaction  The transaction to be signed (a object that matches the RpcAPI structure).
   * @param options  Options for tapos fields
   */


  _createClass(WaxUser, [{
    key: "signTransaction",
    value: function () {
      var _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transaction, options) {
        var account, completedTransaction;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.wax.login();

              case 3:
                account = _context.sent;

                if (!(account !== this.accountName)) {
                  _context.next = 8;
                  break;
                }

                throw new Error('Account does not match the requested permission');

              case 8:
                this.api = this.wax.api;
                this.rpc = this.wax.api.rpc;

              case 10:
                _context.next = 12;
                return this.wax.api.transact(transaction, options);

              case 12:
                completedTransaction = _context.sent;
                return _context.abrupt("return", this.returnEosjsTransaction(options.broadcast !== false, completedTransaction));

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                throw new UALWaxError_1.UALWaxError(_context.t0.message ? _context.t0.message : 'Unable to sign transaction', universal_authenticator_library_1.UALErrorType.Signing, _context.t0);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16]]);
      }));

      function signTransaction(_x, _x2) {
        return _signTransaction.apply(this, arguments);
      }

      return signTransaction;
    }()
  }, {
    key: "signArbitrary",
    value: function () {
      var _signArbitrary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new UALWaxError_1.UALWaxError('WAX Cloud Wallet does not currently support signArbitrary', universal_authenticator_library_1.UALErrorType.Unsupported, null);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function signArbitrary() {
        return _signArbitrary.apply(this, arguments);
      }

      return signArbitrary;
    }()
  }, {
    key: "verifyKeyOwnership",
    value: function () {
      var _verifyKeyOwnership = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throw new UALWaxError_1.UALWaxError('WAX Cloud Wallet does not currently support verifyKeyOwnership', universal_authenticator_library_1.UALErrorType.Unsupported, null);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function verifyKeyOwnership() {
        return _verifyKeyOwnership.apply(this, arguments);
      }

      return verifyKeyOwnership;
    }()
  }, {
    key: "getAccountName",
    value: function () {
      var _getAccountName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.accountName);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAccountName() {
        return _getAccountName.apply(this, arguments);
      }

      return getAccountName;
    }()
  }, {
    key: "getChainId",
    value: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.chain.chainId);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getChainId() {
        return _getChainId.apply(this, arguments);
      }

      return getChainId;
    }()
  }, {
    key: "getKeys",
    value: function () {
      var _getKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.pubKeys);

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getKeys() {
        return _getKeys.apply(this, arguments);
      }

      return getKeys;
    }()
  }, {
    key: "getIsTemp",
    value: function () {
      var _getIsTemp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.isTemp);

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getIsTemp() {
        return _getIsTemp.apply(this, arguments);
      }

      return getIsTemp;
    }()
  }]);

  return WaxUser;
}(universal_authenticator_library_1.User);

exports.WaxUser = WaxUser;